import React from 'react';
import Spinner from 'react-spinner';

require('react-spinner/react-spinner.css');
const SimpleSpinner = () => {
  return <Spinner size="lg" color="primary" />;
};

export default SimpleSpinner;
